import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Mail, MessageCircle } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { Logo } from "./Header";

const Col = ({ title, links }) => (
  <div>
    <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#A0A0A0] mb-4">{title}</h4>
    <ul className="space-y-2.5">
      {links.map(([l, to]) => (
        <li key={l}><Link to={to} className="text-sm text-[#E6E6E6] hover:text-[#00C8FF] transition-colors">{l}</Link></li>
      ))}
    </ul>
  </div>
);

export default function Footer() {
  const { settings } = useStore();
  const c = settings?.company || {};
  const s = settings?.social || {};
  const wa = settings?.whatsapp?.number;
  return (
    <footer className="border-t border-[#282D37] bg-[#050608] mt-12 lg:mt-24 no-print" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-8 py-10 lg:py-16 grid gap-8 lg:gap-12 grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div className="max-w-sm col-span-2 lg:col-span-1">
          <Logo className="h-14" />
          <p className="text-sm text-[#A0A0A0] mt-5 leading-relaxed">A E³ transforma ideias em objetos reais com impressão 3D de precisão. Produção própria, design autoral e personalização de verdade.</p>
          <div className="flex gap-2 mt-6">
            {[[s.instagram, Instagram, "Instagram"], [s.youtube, Youtube, "YouTube"], [s.facebook, Facebook, "Facebook"]].filter(([u]) => u).map(([u, I, n]) => (
              <a key={n} href={u} target="_blank" rel="noreferrer" aria-label={n} className="h-10 w-10 grid place-items-center rounded-xl border border-[#282D37] hover:border-[#008CFF]"><I className="h-4 w-4" /></a>
            ))}
          </div>
        </div>
        <Col title="Institucional" links={[["Sobre a E³", "/politicas/sobre"], ["Empresas", "/empresas"], ["Personalizados", "/personalizados"], ["Blog", "/blog"]]} />
        <Col title="Políticas" links={[["Privacidade", "/politicas/privacidade"], ["Termos de Uso", "/politicas/termos"], ["Trocas", "/politicas/trocas"], ["Entrega", "/politicas/entrega"], ["Personalizados", "/politicas/personalizados"], ["Cookies", "/politicas/cookies"]]} />
        <div>
          <Col title="Atendimento" links={[["Minha Conta", "/minha-conta"], ["Meus Pedidos", "/minha-conta?tab=pedidos"], ["Favoritos", "/favoritos"]]} />
          <div className="mt-4 space-y-2 text-sm text-[#E6E6E6]">
            {wa && <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-[#00C8FF]"><MessageCircle className="h-4 w-4" />WhatsApp</a>}
            {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-2 hover:text-[#00C8FF]"><Mail className="h-4 w-4" />{c.email}</a>}
          </div>
        </div>
      </div>
      <div className="border-t border-[#171A1F]">
        <div className="max-w-[1440px] mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-[#A0A0A0]">
          <span>© {new Date().getFullYear()} {c.name || "E³ Impressão 3D"} {c.cnpj && `· CNPJ ${c.cnpj}`} · eaocubo.com.br</span>
          <div className="flex gap-2 items-center flex-wrap justify-center" data-testid="footer-payments">
            {["Pix", "Visa", "Mastercard", "Elo", "Boleto", "Mercado Pago"].map((m) => <span key={m} className="chip border border-[#282D37] text-[#E6E6E6]">{m}</span>)}
          </div>
        </div>
      </div>
    </footer>
  );
}
